module.exports = __webpack_public_path__ + "static/img/star_person_team.9b16bb57.png";